export const PAGE_TYPE = {
  CATEG: 'Listing',
  PRODUCT: 'ProductPage',
  CATEG_LISTING: 'LinkListingPage',
  HOME_PAGE: 'HomePage',
  SEARCH: 'Search',
  LANDING: 'LandingPage',
  LANDING_CUSTOMER_LOYALTY: 'LandingPageCustomerLoyalty',
  BLOG_HOME: 'BlogHomePage',
  BLOG_CATEG: 'BlogCategPage',
  BLOG_TAG: 'BlogTagPage',
  BLOG_ARCHIVE: 'BlogArchivePage',
  BLOG_ARTICLE: 'BlogArticlePage',
};

export const CUSTOM_PAGE_VIEW_EVENT = {
  CS_ADDRESS_POPIN_OPEN_PV: 'CS_ADDRESS_POPIN_OPEN_PV',
  CS_ADDRESS_POPIN_CLOSE_PV: 'CS_ADDRESS_POPIN_CLOSE_PV',
  CS_WB_POPIN_OPEN_PV: 'CS_WB_POPIN_OPEN_PV',
  CS_WB_POPIN_OPEN_CSR_URL_PV: 'CS_WB_POPIN_OPEN_CSR_URL_PV',
  CS_WB_POPIN_CLOSE_CART_PV: 'CS_WB_POPIN_CLOSE_CART_PV',
  CS_WB_POPIN_CLOSE_EMPTY_PV: 'CS_WB_POPIN_CLOSE_EMPTY_PV'
};

export const CUSTOM_PAGE_VIEW_TYPE = {
  CHECKOUT_CREATE_ADDRESS: 'CheckoutCreateAddress',
  CHECKOUT_EDIT_ADDRESS: 'CheckoutEditAdress',
  PROFILE_CREATE_ADDRESS: 'ProfileCreateAddress',
  PROFILE_EDIT_ADDRESS: 'ProfileEditAdress',
  MODAL_WINEBOX: 'ModalWinebox'
};

export const CS_CUSTOM_ERROR = {
  ADYEN: 'ADYEN',
  HIPAY: 'HIPAY',
  ADD_PRODUCT: 'ADD_PRODUCT'
};
